/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/**
 * Mocks html parsing since the dependency is quite large.
 * @param {string} str HTML string.
 */
import React from 'react';
export default function mockHtmlParser(str) {
  const token = '##--##';
  if (str.startsWith(token)) {
    return <span dangerouslySetInnerHTML={{__html: str.replace(token, '')}}/>;
  }
  return str;
}
